import { LinkAsButton_default } from "./chunk-4QQB43WX.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/SliderInput/SliderInput.tsx
import { useCallback, useEffect, useState } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var SliderInput = _a => {
  var _b = _a,
    {
      id,
      name,
      value,
      min,
      max,
      step,
      onChange,
      anchors,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "value", "min", "max", "step", "onChange", "anchors", "className"]);
  const [maxValue, setMaxValue] = useState(value || max);
  const maxPosition = (maxValue - min) / (max - min) * 100;
  const handleMaxChange = useCallback(event => {
    event.preventDefault();
    const newMaxVal = +event.target.value;
    if (typeof value === "undefined") {
      setMaxValue(newMaxVal);
    }
    onChange == null ? void 0 : onChange(newMaxVal);
  }, [value, onChange]);
  useEffect(() => {
    if (typeof value !== "undefined") {
      setMaxValue(value);
    }
  }, [value]);
  return /* @__PURE__ */jsxs("div", {
    className: clsx("pd:flex pd:flex-col pd:gap-1", className),
    children: [/* @__PURE__ */jsxs("div", {
      className: "pd:relative pd:z-0 pd:h-5",
      children: [/* @__PURE__ */jsx("input", __spreadValues({
        id: name,
        name,
        type: "range",
        min,
        max,
        step,
        value: maxValue,
        onChange: handleMaxChange,
        className: "pd:slider-input__input pd:slider-input__input--max pd:absolute pd:inset-x-[-0.625rem] pd:z-[3] pd:h-5 pd:appearance-none pd:opacity-0 pd:focus:ring-2 pd:ring-primary-600"
      }, rest)), /* @__PURE__ */jsx("div", {
        className: "pd:slider-input__track pd:absolute pd:inset-x-0 pd:top-[0.375rem] pd:h-2 pd:rounded-full pd:bg-dim-200"
      }), /* @__PURE__ */jsx("div", {
        className: "pd:absolute pd:left-0 pd:top-[0.375rem] pd:h-2 pd:rounded-full pd:bg-primary-500",
        style: {
          right: "".concat(100 - maxPosition, "%")
        }
      }), /* @__PURE__ */jsx("div", {
        style: {
          left: "".concat(maxPosition, "%")
        },
        className: "pd:slider-input__thumb--max pd:absolute pd:z-[2] pd:ml-[-0.625rem] pd:size-5 pd:rounded-full pd:border-2 pd:border-primary-600 pd:bg-white"
      })]
    }), anchors && /* @__PURE__ */jsx("nav", {
      className: "pd:relative pd:h-5",
      children: /* @__PURE__ */jsx("ul", {
        children: anchors.map(anchor => anchor.value <= max && anchor.value >= min ? /* @__PURE__ */jsx("li", {
          children: /* @__PURE__ */jsx(LinkAsButton_default, {
            type: "button",
            onClick: () => {
              if (!value) {
                setMaxValue(anchor.value);
              }
              onChange == null ? void 0 : onChange(anchor.value);
            },
            "aria-controls": id,
            style: {
              left: "".concat((anchor.value - min) / (max - min) * 100, "%")
            },
            className: clsx("pd:absolute pd:-translate-x-1/2 pd:leading-5", value === anchor.value && "pd:text-primary-600"),
            children: anchor.label || anchor.value
          })
        }, anchor.value) : null)
      })
    })]
  });
};
var SliderInput_default = SliderInput;
export { SliderInput_default };